// extracted by mini-css-extract-plugin
export var actions = "style-module--actions--568af";
export var documentList = "style-module--document-list--ac398";
export var filterSection = "style-module--filter-section--28980";
export var header = "style-module--header--a5bb2";
export var icon = "style-module--icon--846a8";
export var title = "style-module--title--c7bb3";